import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { MailConfigurationUpdateInterface } from '../models/mail-configuration-update.interface';
import { MailConfigurationInterface } from '../models/mail-configuration.interface';

export const  GetMailConfigurationsQuery = gql`query mailConfigurations($clinicId: Long!) {
  mailConfigurations (clinicId: $clinicId, order: { mailType: ASC, profile: ASC, isNewUser : ASC  }) {
      id
      message
      subject
      profile
      clinicId
      isNewUser
      mailType
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class MailConfigurationService {
  constructor(private readonly apollo: Apollo) { }

  getMailConfigurations(clinicId: number): Observable<MailConfigurationInterface[]> {
    return this.apollo.query<GetMailConfigurationsQueryInterface>({
      query: GetMailConfigurationsQuery,
      variables: { clinicId }
    }).pipe(map(res => res.data.mailConfigurations));
  }

  updateMailConfiguration(mailConfigurationDto: MailConfigurationUpdateInterface, clinicId: number): Observable<MailConfigurationInterface | undefined> {
    return this.apollo.mutate<{ updateMailConfiguration: MailConfigurationInterface }>({
      mutation : gql`mutation updateMailConfiguration($dto: MailConfigurationDtoInput) {
        updateMailConfiguration(dto: $dto) {
          id
          message
          subject
          profile
          clinicId
          isNewUser
          mailType
        }
      }`,
      variables: {
        dto: {
          id: mailConfigurationDto.id,
          message: mailConfigurationDto.message,
          subject: mailConfigurationDto.subject
        }
      },
      refetchQueries: [{
        query: GetMailConfigurationsQuery,
        variables: { clinicId }
      }],
      update: (store, data) => {

        // Read the data from our cache for this query.
        const mailConfigurationsQuery = store.readQuery<GetMailConfigurationsQueryInterface>({ query: GetMailConfigurationsQuery, variables: { clinicId } });
        if (mailConfigurationsQuery && data?.data) {
          let mailConfigurations = mailConfigurationsQuery.mailConfigurations.map(m => ({ ...m }));

          const mailConfiguration = mailConfigurations.find(k => k.id === mailConfigurationDto.id);
          if (mailConfiguration && !mailConfiguration.clinicId ) {

            mailConfigurations = mailConfigurations.filter(m=>m.id !== mailConfigurationDto.id);
            mailConfigurations.push(data.data?.updateMailConfiguration);
          }

          store.writeQuery<GetMailConfigurationsQueryInterface>({ query: GetMailConfigurationsQuery, data: { mailConfigurations }, variables: { clinicId } });
        }
      },
    }).pipe(map(res => res.data ? res.data.updateMailConfiguration : undefined));
  }
}

export interface GetMailConfigurationsQueryInterface {
  mailConfigurations: MailConfigurationInterface[];
}
